BoardBackground = require 'models/board-background'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'

module.exports = class BoardBackgroundList extends CollectionWithHelpers
  model: BoardBackground
  url: -> "/1/member/#{ @member.id }/boardBackgrounds"

  initialize: (list, { @member }) ->



// WEBPACK FOOTER //
// ./app/scripts/models/collections/board-background-list.coffee